import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Start")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Stop")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("| ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Clear")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "input", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "per page", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BtnHref = _resolveComponent("BtnHref")!
  const _component_ServerInOutPortsSelect = _resolveComponent("ServerInOutPortsSelect")!
  const _component_Page = _resolveComponent("Page")!

  return (_openBlock(), _createBlock(_component_Page, {
    text: "Input monitor",
    isShowHeader: _ctx.showHeader
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", null, [
        (!_ctx.isMonitoring)
          ? (_openBlock(), _createBlock(_component_BtnHref, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.startMonitoring()))
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isMonitoring)
          ? (_openBlock(), _createBlock(_component_BtnHref, {
              key: 1,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.stopMonitoring()))
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _hoisted_3,
        _createVNode(_component_BtnHref, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.doClear()))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("p", null, [
        _createVNode(_component_ServerInOutPortsSelect, {
          modelValue: _ctx.inputToMonitor,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inputToMonitor) = $event)),
          modelModifiers: { number: true },
          mode: "in"
        }, null, 8, ["modelValue"]),
        _hoisted_5
      ]),
      _createElementVNode("p", null, [
        _withDirectives(_createElementVNode("input", {
          class: "w3-input",
          type: "number",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.perPage) = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.perPage,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_6
      ]),
      _createElementVNode("pre", null, _toDisplayString(_ctx.data.join("\n")) + "            \n    ", 1)
    ]),
    _: 1
  }, 8, ["isShowHeader"]))
}